import React, { useEffect, useState } from "react";
import {
  Container,
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Box,
  Typography,
  Alert, // Import Alert component
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import google from "../assets/google.png";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../auth/authSlice";
import { getUser, changePassword } from "../PHP/ApiCalls";

const theme = createTheme();

function Login() {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated, status, error } = useSelector((state) => state.auth);
  const [userEmail, setEmail] = useState("");
  const [forgetPasswordDiv, setdiv] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  useEffect(() => {
    if (isAuthenticated) {
      nav("/");
    }
  }, [isAuthenticated, nav]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const input = {
      email: data.get("email"),
      password: data.get("password"),
    };

    dispatch(login(input));
  };

  const changePass = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const newPass = data.get("newpassword");
    const confirmPass = data.get("newpasswordConfirm");
    let curEmail = userEmail;

    if (!PASSWORD_REGEX.test(newPass)) {
      setPasswordError(
        "Password must be at least 8 characters long, contain an uppercase letter, a lowercase letter, a number, and a special character."
      );
      return;
    }

    if (newPass !== confirmPass) {
      setPasswordError("Passwords do not match");
      return;
    }

    changePassword(curEmail, newPass)
      .then((response) => {
        if (response) {
          setPasswordError("");
          setdiv(false);
          nav("/Login");
        }
      })
      .catch(() => {
        setPasswordError("Failed to change password. Please try again.");
      });
  };

  const checkIFEmailExists = () => {
    let curEmail = userEmail;

    getUser(curEmail)
      .then((response) => {
        console.log("Login Forget Response: ", response);
        if (response.status === "success") {
          setdiv(true);
        }
      })
      .catch((e) => {
        console.log(e);
        //  setError("Email not found");
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        {!forgetPasswordDiv ? (
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 6,
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={status === "loading"}
              >
                Sign In
              </Button>

              <Grid container>
                <Grid item xs>
                  <Button
                    onClick={checkIFEmailExists}
                    variant="text"
                    style={{
                      color: "blue",
                      textDecoration: "none",
                      fontSize: "0.75rem",
                    }}
                  >
                    Forgot password?
                  </Button>
                </Grid>
                <Grid item>
                  <RouterLink
                    to="/SignUp"
                    style={{
                      color: "blue",
                      textDecoration: "none",
                      fontSize: "0.75rem",
                    }}
                  >
                    Don't have an account? Sign Up
                  </RouterLink>
                </Grid>
              </Grid>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 6,
            }}
            className="cont"
            component={"form"}
            onSubmit={changePass}
          >
            <div className="inner">
              <h2 className="head">Change your Password</h2>
              <TextField
                margin="normal"
                required
                fullWidth
                name="newpassword"
                label="New Password"
                type="password"
                id="newpassword"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="newpasswordConfirm"
                label="Confirm New Password"
                type="password"
                id="newpasswordConfirm"
              />
              {passwordError && (
                <p className="error" style={{ fontSize: "0.75rem" }}>
                  {passwordError}
                </p>
              )}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Change
              </Button>
            </div>
          </Box>
        )}
      </Container>
    </ThemeProvider>
  );
}

export default Login;
